import { render, staticRenderFns } from "./ImagesGrid.vue?vue&type=template&id=35c5e89b&scoped=true&"
import script from "./ImagesGrid.vue?vue&type=script&lang=ts&"
export * from "./ImagesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesGrid.vue?vue&type=style&index=0&id=35c5e89b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5e89b",
  null
  
)

export default component.exports